// Display limits for courses and projects in the StatusBox
export const MAX_COURSES_DISPLAYED = 2;
export const MAX_PROJECTS_DISPLAYED = 1;

// Test ID for the StatusBox component
export const STATUS_BOX_TEST_ID = 'status-box';
